import React, {Component} from 'react';
import {Redirect, Link} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import ViewQuestionSetup from './ViewQuestionSetup';
const GLOBAL = require('../Globals');

class ExamList extends Component {
	 
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			idd : '',
			acyear : '',
			cls : '',
			section : '',
			value : [],
			type : '',
			suborder : '',
			subje : '',
			stype : '',
			sorder : '',
			isdisplay : 0,
			_message : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : [],
			subj : [],
			_redirect : false,
			subject :[],
			modal: false,
			assub : [],
			data : [],
			editData : [],
			isbtnview : false,
			viewmodal : false,
			isview : false,
		}
		this.onacChange = this.onacChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	onViewClick(id,e){
		var dat = this.state.data.filter(function(obj){
			return (obj.questionid == id);
		})
		this.setState({questionid : id,viewmodal : true});
	}
	
	onacChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			GetData('question/deletequestionsetup/'+this.state.id).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Question Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getSetupQuestion();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Question',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}

	onUpdate(id){
		var dat = this.state.data.filter(function(obj){
			return (obj.questionid == id);
		})
		this.setState({editData : dat,questionid : id,_redirect : true});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getExamSetup();
			}
		});
	}

	getExamSetup(){
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('question/getexamsetup/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
  render() {
	
	var acyear = this.state.accyear;

	if(this.state._redirect){
		  
		return (<Redirect to={'/questions/editsetup/'+this.state.questionid} />);
    }

    return (
		<div>
		  <QuestionPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  
						<CardHeader>
							<strong>List of Exams</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>
							<Link to="/questions/examsetup" className="btn btn-success" style={{float : 'right'}} >Add</Link>
						</CardHeader>
						<CardBody id="asubbody">
							<Row style={{marginTop : '20px'}}>
								<Col md="12">
									<Table responsive bordered >
										<thead>
											<tr>
												<th>S.No</th>
												<th>Exam Name</th>
												<th>Class</th>
												<th>Subject</th>
												<th>Question Id</th>
												<th>Mark per Question</th>
												<th>Total Mark</th>
												<th>Exam Time Limit</th>
												<th>Date</th>
												<th>Time</th>
												<th>Reminder Type</th>
											</tr>
										</thead>
										<tbody>
											{this.state.data.map((item,i)=>
												<tr>
													<td>{i+1}</td>
													<td>{item.examname}</td>
													<td>{item.clsname} - {item.secname}</td>
													<td>{item.subname}</td>
													<td>{item.questionname}</td>
													<td>{item.noofmarks}</td>
													<td>{parseFloat(item.totalmarks)}</td>
													<td>{item.timelimit}</td>
													<td>{item.examdate}</td>
													<td>{item.fromtime} to {item.totime}</td>
													<td style={{textTransform : 'capitalize'}}>{item.reminder}</td>
												</tr>
											)}
										</tbody>
									</Table>
								</Col>
						  	</Row>
							<Modal isOpen={this.state.viewmodal} size="lg" toggle={()=>{this.setState({viewmodal : false})}} className={this.props.className}>
								<ModalHeader toggle={()=>{this.setState({viewmodal : false})}}>View Question Setup - {this.state.questionid}</ModalHeader>
								<ModalBody>
									<ViewQuestionSetup id={this.state.questionid} />
								</ModalBody>
							</Modal>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default ExamList;


// WEBPACK FOOTER //
// ./src/Questions/ExamList.js